import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'autoUploadTip'
})
export class AutoUploadTipPipe implements PipeTransform {

  transform(value: string): any {
    let tips
    if(value){
      tips = value.split('；')
    } else {
      tips = []
    }
    let fileTypeTip = tips[0]
    if(fileTypeTip && fileTypeTip.indexOf('请在上传策略中配置允许上传类型') == -1){
      let typeStr = fileTypeTip.split('：')[1]
      let newTypeStr = typeStr
      let typeArr = typeStr.split('、')
      if(typeArr.length > 3){
        //先匹配是否包含 png、jpg、jpeg，若全包含，则显示这三条，若不全包含，则显示三条(包含的、typeArr排序前面的)
        let arrs = []
        let others = []
        typeArr.forEach(ele => {
           if(ele == 'png' || ele == 'jpg' || ele == 'jpeg'){
             arrs.push(ele)
           }else {
            others.push(ele)
           }
        });
        if(arrs.length >= 3){
          newTypeStr = arrs[0]+'、'+arrs[1]+'、'+arrs[2]+' 等'
        }else {
          if(arrs.length == 2){
            newTypeStr = arrs[0]+'、'+arrs[1]+'、'+others[1]+' 等'
          }else if(arrs.length == 1){
            newTypeStr = arrs[0]+'、'+others[0]+'、'+others[1]+' 等'
          }else {
            newTypeStr = others[0]+'、'+others[1]+'、'+others[2]+' 等'
          }
          
        }
        
      }
      let newValue = value.replace(typeStr,newTypeStr)
      return newValue
    } else {
      return value;
    }
  }

}
